import { useEffect, useState } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useDictionary, useClient } from '@adamlip/okeoke.client';
import SubmittedOrderHeaderV2 from 'components/SubmittedOrder/SubmittedOrderHeaderV2';
import SubmittedOrderItemListV2 from 'components/SubmittedOrder/SubmittedOrderItemListV2';

function OrderHistory(props) {
  const { limit, limitDays, itemList, navigateTo } = props;

  const navigate = useNavigate();
  const { getValue } = useDictionary();
  const { client, socketAuthenticated } = useClient();

  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (socketAuthenticated) loadUserOrders();
    // eslint-disable-next-line
  }, [socketAuthenticated]);

  const loadUserOrders = () => {
    client
      .getUserOrders(
        moment()
          .subtract(limitDays != null ? limitDays : 365, 'd')
          .format('YYYY-MM-DD'),
        moment().add(1, 'days').format('YYYY-MM-DD')
      )
      .then((res) => {
        setOrders(res.data);
      });
  };

  const navigateToOrderView = (uuid) => {
    if (uuid == null) return null;
    navigate(`/orderview/${uuid}`);
  };

  const navigateToDetails = (uuid) => {
    if (uuid == null) return null;
    navigate(`/orderdetails/${uuid}`);
  };

  const goToOrder = () => navigate('/order');

  const handleNavigate = (uuid) => {
    if (navigateTo == null || navigateTo === 'orderview') navigateToOrderView(uuid);
    if (navigateTo === 'orderdetails') navigateToDetails(uuid);
  };

  if (typeof orders !== 'object')
    return (
      <div className='orderHistory-root'>
        <h2>{getValue('app_v2_orderHistory_noOrders')}</h2>
        <div className='btn primary' onClick={goToOrder}>
          {getValue('app_v2_orderHistory_start')}
        </div>
      </div>
    );

  let orderArray = Object.values(orders || {}).filter((order) => order.orderState >= 90);

  if (orderArray.length === 0)
    return (
      <div className='orderHistory-root'>
        <h2>{getValue('app_v2_orderHistory_noOrders')}</h2>
        <div className='btn primary' onClick={goToOrder}>
          {getValue('app_v2_orderHistory_start')}
        </div>
      </div>
    );

  if (limit != null) orderArray = orderArray.slice(0, limit);

  return (
    <div className='orderHistory-root flex flex-col gap-2 !p-2'>
      {orderArray.map((order) => {
        return (
          <div
            className='m-0 border-b-none bg-[var(--main-secondary-bg-color)] rounded-[var(--general-border-radius)] p-2'
            key={order.uuid}
            onClick={() => {
              handleNavigate(order.uuid);
            }}>
            <SubmittedOrderHeaderV2 order={order} />
            {itemList != null && <SubmittedOrderItemListV2 order={order} className='orderHistory-itemList' />}
          </div>
        );
      })}
    </div>
  );
}

export default OrderHistory;
